/*
  This hook is used to fetch in-store offers section title
*/

import { useEffect, useMemo } from 'react';
import { fetchPlacements } from 'core/actions/ocapi';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectInstoreConfig,
  makeSelectInstoreTitleOffers,
  makeSelectInstoreOffersTitleIsLoaded,
  makeSelectInstoreOffersTitleIsLoading,
} from '../selectors';

export const useGetInstoreOffersTitle = ({
  namespace = '', componentParams = {}, staticTitle = '',
}) => {
  const dispatch = useDispatch();
  const config = useSelector(selectInstoreConfig);
  const { instoreOffers: { api } } = config;
  const { params: configParams, options: configOptions } = api.title;

  const params = {
    ...configParams,
    ...componentParams,
  };

  const options = {
    ...configOptions,
    namespace,
  };

  const selectInstoreOffersTitleIsLoading = useMemo(makeSelectInstoreOffersTitleIsLoading, []);
  const selectInstoreOffersTitleIsLoaded = useMemo(makeSelectInstoreOffersTitleIsLoaded, []);
  const selectInstoreTitleOffers = useMemo(makeSelectInstoreTitleOffers, []);

  const isLoading = useSelector(state => selectInstoreOffersTitleIsLoading(state, namespace));
  const isLoaded = useSelector(state => selectInstoreOffersTitleIsLoaded(state, namespace));
  const title = useSelector(state => selectInstoreTitleOffers(state, namespace));

  useEffect(() => {
    if (staticTitle) {
      return () => {};
    }

    if (!isLoaded && !isLoading) {
      dispatch(fetchPlacements(params, options));
    }

    return () => {};
  }, [isLoaded, isLoading]);

  return {
    title: staticTitle || title,
  };
};
